// The AMP admin Entitlements pages manage only the external-tenant amp and
// mobile domains. jupiter/bess/ai live in the internal tenant and are managed
// by their own apps; general is shared plumbing, not an admin-managed domain.
export const AMP_ENTITLEMENT_DOMAINS = ["amp", "mobile"];

export const isAmpEntitlementDomain = (domain?: string | null): boolean =>
  AMP_ENTITLEMENT_DOMAINS.includes((domain || "").toLowerCase());

// Users of the amp and mobile domains are external-tenant (EXT) identities.
// The same person can also hold an INTERNAL row for jupiter/bess, which these
// pages must not show or edit.
export const EXTERNAL_TENANT_USERS_QUERY = "tenant_type=EXT";

// Every user AMP adds is an external-tenant identity: the entitlements service
// finds or invites them in the external CIAM tenant. (Internal users are never
// added from AMP -- the service refuses an INTERNAL add from the AMP-UI product.)
export const AMP_USER_TENANT_TYPE = "EXT";

// An entitlements service that predates tenant_type returns no field; every
// row before tenancy existed was EXT, so treat a missing value as EXT.
export const isExternalTenantUser = (user: {
  tenant_type?: string | null;
}): boolean => (user.tenant_type || "EXT").toUpperCase() === "EXT";

// Mobile has no endpoint groups of its own: each mobile role is granted amp's
// MOBILE-APP-CORE endpoint group (formerly AMP-USER-ALL), with the role-POG
// mapping stored under the ROLE's domain ('mobile'), which is what
// MOBILE_USER_ENTITLEMENTS_V matches on. So any amp/mobile role may pick any amp/mobile endpoint group, mappings
// are always written under the role's domain, and asset groups (collections)
// must match the role's own domain (MobileApp_<Asset>_Read for mobile).
export const collectionDomainsForRole = (roleDomain?: string | null): string[] => [
  (roleDomain || "amp").toLowerCase(),
];

// Pickers only list amp/mobile items, but an existing record may already hold
// an item the picker hides. Rebuild the selection from what the picker changed
// without silently dropping those hidden items.
export const keepHiddenSelections = <T>(
  current: T[],
  visible: T[],
  pickedFromVisible: T[]
): T[] => {
  const visibleSet = new Set(visible);
  return [...current.filter((id) => !visibleSet.has(id)), ...pickedFromVisible];
};
